const config = {
  ENVIRONMENT_NAME: 'staging',
  forwoodId: {
    URL: 'https://id.staging.oceanagold.forwoodsafety.com',
    USER_TOKEN_URL: 'https://mv0gwi14sk.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  apiGateway: {
    REGION: 'ap-southeast-1',
    URL: 'https://qhe6y5bxp9.execute-api.ap-southeast-1.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'admin-container-1.11.5',
    HOSTNAME: 'https://admin.staging.oceanagold.forwoodsafety.com',
    COMPANY_MICROFRONTEND_URL: 'https://company.staging.oceanagold.forwoodsafety.com',
    PHYSICAL_LOCATION_MICROFRONTEND_URL: 'https://locations.staging.oceanagold.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.oceanagold.forwoodsafety.com',
    WEBSOCKET: 'wss://auduqo2dzb.execute-api.ap-southeast-1.amazonaws.com/staging'
  },
  get forwoodIdAuthUrl() {
    return `${this.forwoodId.URL}/authorize?response_type=token&scope=openid&client_id=${this.forwoodId.APP_CLIENT_ID}&redirect_uri=${this.reactApp.HOSTNAME}&state=`;
  }
};

export default config;
